// Firebase SDK initialization
// Provides auth and storage instances for use throughout the app

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import env from '@/utils/env';

// Initialize Firebase app with config from environment
const app = initializeApp(env.firebase);

// Export auth and storage instances
export const auth = getAuth(app);
export const storage = getStorage(app);

// Also export the app instance for advanced use cases
export { app };
